import React, { memo } from 'react';
import { CreditCardProps } from '../../types';
import { APP_CONFIG } from '../../constants';
import styles from './CreditCard.module.css';

// Import the new assets
import mastercardLogo from '../../assets/images/mastercard-logo.svg';
import chipYellow from '../../assets/images/chip-yellow.svg';
import tapLogo from '../../assets/images/tap-logo.svg';
import wifiIcon from '../../assets/images/wifi-icon.svg';

const MastercardLogo: React.FC = memo(() => (
    <div className={styles.mastercardLogo}>
        <img src={mastercardLogo} alt="Mastercard" className={styles.mastercardIcon} />
    </div>
));

const CardChip: React.FC = memo(() => (
    <div className={styles.cardChip}>
        <img src={chipYellow} alt="Card Chip" className={styles.chipIcon} />
    </div>
));

const ProfileSection: React.FC = memo(() => (
    <div className={styles.profileSection}>
        <div className={styles.profileContainer}>
            <img src={tapLogo} alt="Tap" className={styles.profileImage} />
            <div className={styles.profileOverlay}></div>
        </div>
    </div>
));

const WifiIcon: React.FC = memo(() => (
    <div className={styles.wifiIcon}>
        <img src={wifiIcon} alt="WiFi" className={styles.wifiImage} />
    </div>
));

const CreditCard: React.FC<CreditCardProps> = memo(({ className = '' }) => {
    return (
        <div className={`${styles.creditCard} ${className}`}>
            {/* Yellow glow ellipse */}
            <div className={styles.cardGlow}></div>

            {/* Card content container */}
            <div className={styles.cardContent}>
                <CardChip />
                <ProfileSection />
            </div>

            {/* Mastercard logo */}
            <MastercardLogo />

            {/* WiFi icon */}
            <WifiIcon />

            {/* Dayli brand text */}
            <div className={styles.cardBrandText}>{APP_CONFIG.BRAND_NAME}</div>
        </div>
    );
});

CreditCard.displayName = 'CreditCard';
MastercardLogo.displayName = 'MastercardLogo';
CardChip.displayName = 'CardChip';
ProfileSection.displayName = 'ProfileSection';
WifiIcon.displayName = 'WifiIcon';

export default CreditCard; 